/**
 * Тумблер «Внутренние звонки» — только админу и только на установке с Asterisk. На других
 * телефониях понятия «внутренний звонок» у нас нет: направление 0 там значит «не удалось
 * определить», и сервер запись настройки отвергает (409).
 */
export const canManageInternalCalls = (user, features) =>
  user?.role === 'admin' && features?.asteriskEnabled === true;

export const internalCallsToast = (analyze) =>
  analyze ? 'Внутренние звонки анализируются' : 'Внутренние звонки не анализируются';
